import * as React from 'react';

import type { HeadProps, PageProps } from 'gatsby';
import { StaticImage } from 'gatsby-plugin-image';

import { CtaBlock } from 'stile-shared/src/components/2020/blocks/CtaBlock';

import { PageLayout } from 'templates/2024/PageLayout';
import { SEO } from 'templates/2024/SEO';

import { ResourceAccessBlock } from 'components/common/ResourceAccessBlock';

export function Head(props: HeadProps) {
  return (
    <SEO
      title="Australian Curriculum v9.0"
      description="2024 teacher planning resource"
      slug={props.location.pathname}
    />
  );
}

function ACV9Page(props: PageProps) {
  return (
    <PageLayout {...props}>
      <ResourceAccessBlock
        title="Australian Curriculum v9.0"
        subtitle="2024 teacher planning resource"
        id="AC_V9"
        redirectUrl="https://stileapp.com/go/v92024"
        image={
          <StaticImage
            src="../../../../stile-shared/assets/images/resources/ac_9_2024.png"
            alt=""
          />
        }
      >
        <p>
          Stile is a complete, coherent curriculum for Australian science classrooms. This Scope and
          Sequence is aligned to Version 9.0 of the Australian Curriculum.
        </p>
        <p>
          It offers a world-class starting point for designing your school’s science curriculum. It
          can be used in its current format alongside our comprehensive teaching plan, or it can be
          customised to best suit your unique context.
        </p>
      </ResourceAccessBlock>

      <CtaBlock />
    </PageLayout>
  );
}

export default ACV9Page;
